<template>
    <div class="field is-horizontal">
        <div class="field-body">
            <div class="display-flex">
                <label class="radio upcoming-radio">
                    <input type="radio" :value="false" v-model="auctionType">
                    Upcoming
                </label>

                <label class="radio past-radio">
                    <input type="radio" :value="true" v-model="auctionType">
                    Past Auction Result
                </label>

            </div>


        </div>
    </div>
</template>

<script>
    export default {
        computed: {
            auctionType: {
                get() {
                    return this.$store.getters.getStatsStatusStock
                },
                set(value) {
                    this.$store.dispatch('setStatsStatusStock', value)
                }
            }
        }
    }

</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/StockCars/AuctionTypeStockCar.vue